
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { EtiquetteModel } from 'src/models/pilotage/contextePilotageUtilisateurModel';
import { EtiquetteService } from 'src/services/etiquette.service';

@Component({
    selector: 'app-commun-invite',
    templateUrl: './commun-invite.component.html',
    styleUrls: ['./commun-invite.component.scss'],
    imports: [MatDialogModule, TranslateModule, FormsModule]
})
export class CommunInviteComponent implements OnInit, OnChanges, AfterViewInit {
  private sub = new Subscription();
  @Input() roleEntites: { id: number, nom: string, estActif?: boolean | null }[] = [];
  @Input() limiterA5lignes: boolean = false;
  @Input() etiquettesDisponibles: EtiquetteModel[] = [];

  @Output() emailsChanged = new EventEmitter<string[]>();
  @Output() entitySelected = new EventEmitter<number>();
  @Output() etiquettesSelectionnees = new EventEmitter<EtiquetteModel[]>();

  emailInput: string = '';
  emailInvalid: boolean = false;
  entiteIdSelectionne: number | null = null;
  selectedEtiquettes: EtiquetteModel[] = [];
  etiquetteIdSelectionnee: number | null = null;
  availableEtiquettes: EtiquetteModel[] = [];

  constructor(
    public etiquetteService: EtiquetteService
  ) { }

  ngOnInit(): void {

    if (this.roleEntites.length === 1) {
      this.entiteIdSelectionne = this.roleEntites[0].id;
      this.entitySelected.emit(this.entiteIdSelectionne);
    }
    this.availableEtiquettes = [...this.etiquettesDisponibles];
  }

  ngAfterViewInit() {
  }



  ngOnChanges(changes: SimpleChanges) {
    if (changes['etiquettesDisponibles']) {
      this.availableEtiquettes = [...this.etiquettesDisponibles];
      this.selectedEtiquettes = this.selectedEtiquettes.filter(
        selected => this.availableEtiquettes.some(available => available.etiquetteId === selected.etiquetteId)
      );
      this.etiquettesSelectionnees.emit(this.selectedEtiquettes);
    }
  }

  validateEmails(): void {
    const emails = this.emailInput.split('\n').map(e => e.trim());
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    this.emailInvalid = emails.some(email => email && !emailRegex.test(email));

    if (!this.emailInvalid) {
      this.emailsChanged.emit(emails.filter(e => e));
    }
  }

  limitLines(event: any) {
    if (this.limiterA5lignes) {
      const textarea = event.target;
      const lines = textarea.value.split('\n');
      if (lines.length > 5) {
        textarea.value = lines.slice(0, 5).join('\n');
        this.emailInput = textarea.value;
      }
    }
  }

  onEntityChange(): void {
    this.entitySelected.emit(this.entiteIdSelectionne!);
  }

  onEtiquetteSelected(event: Event, selectElement: HTMLSelectElement): void {
    const etiquetteId = Number(selectElement.value);
    const etiquetteSelectionnee = this.availableEtiquettes.find(e => e.etiquetteId === etiquetteId);
    if (etiquetteSelectionnee) {
      this.selectedEtiquettes.push(etiquetteSelectionnee);
      this.availableEtiquettes = this.availableEtiquettes.filter(e => e.etiquetteId !== etiquetteId);
      this.etiquettesSelectionnees.emit(this.selectedEtiquettes);
      selectElement.value = '';
    }
  }

  removeSelectedEtiquette(id: number): void {
    const removedEtiquette = this.selectedEtiquettes.find(e => e.etiquetteId === id);
    this.selectedEtiquettes = this.selectedEtiquettes.filter(e => e.etiquetteId !== id);
    if (removedEtiquette) {
      this.availableEtiquettes.push(removedEtiquette);
      this.availableEtiquettes.sort((a, b) =>
        this.etiquetteService.getNomLocalise(a.locales).localeCompare(
          this.etiquetteService.getNomLocalise(b.locales)
        )
      );
    }
    this.etiquettesSelectionnees.emit(this.selectedEtiquettes);
  }
}
